import { createContext, useContext } from 'react';

const MyContext = createContext();

export function useMyContext() {
  return useContext(MyContext);
}

export default MyContext;